import { createStore } from "vuex";

import users from './modules/users';
import figures from './modules/figure';
import files from './modules/files';
import security from "./modules/security";
import cubes from "./modules/cubes";
import contextmenu from "./modules/contextmenu";
import notifications from "./modules/notifications";
import dynamicforms from "./modules/dynamicforms";
import models from "./modules/models";

export default createStore({
  modules: {
    users,
    figures,
    models,
    files,
    security,
    cubes,
    contextmenu,
    notifications,
    dynamicforms
  }
});
